import { IconButton as MuiIconButton } from "@mui/material"
import { styled } from "@mui/system"
import PropTypes from "prop-types"
import React from "react"

const StyledIconButton = styled(MuiIconButton)(({ theme }) => ({
  // width: "48px",
  // height: "48px",
  borderRadius: "50%",
  border: `2px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.primary.main,
  },
  "&:focus": {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: "2px",
  },
}))

const IconButton = props => {
  return <StyledIconButton {...props} />
}

IconButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  "aria-label": PropTypes.string.isRequired,
  size: PropTypes.oneOf(["small", "medium", "large"]),
}

export default React.memo(IconButton)
